export const moldsExtra = [
  {
    brand: 'Silikomart',
    cavityCount: 15,
    cavityVolume: 26,
    dimensions: '\u00d845 h 20mm',
    id: 10000,
    title: 'Globe 26',
    url: 'https://www.amazon.fr/Silikomart-GLOBE-STAMPO-SILICONE-45/dp/B00KWC2CSY',
  },
  {
    brand: 'Silikomart',
    cavityCount: 1,
    cavityVolume: 1200,
    dimensions: '250mm x 80mm x 80mm',
    id: 10001,
    title: 'Gianduia 1200 ml',
    url: 'https://www.cuisineshop.fr/moules-silikomart-2/moule-silicone-gianduia',
  },
  {
    brand: 'Silikomart',
    cavityCount: 1,
    cavityVolume: 600,
    dimensions: '225mm x 60mm x 79mm',
    id: 10002,
    title: 'Gianduia 600 ml',
    url: 'https://shop.silikomart.com/en/gianduia',
  },
  {
    brand: 'Pavoni',
    cavityCount: 1,
    cavityVolume: 1000,
    dimensions: '250mm x 79mm x 81mm',
    id: 10003,
    title: 'Sublime',
    url: 'https://pavonitalia.com/professional/en/catalog/product/view/id/3181/s/sublime-ke021/',
  },
  {
    brand: 'Silikomart',
    cavityCount: 1,
    cavityVolume: 1250,
    dimensions: '300mm x 100mm x 50mm',
    id: 10004,
    title: 'Sahara 1250 ml',
    url: 'https://www.cuisineshop.fr/moules-silikomart-2/moule-sahara-1250-ml',
  },
  {
    brand: 'Silikomart',
    cavityCount: 8,
    cavityVolume: 85,
    dimensions: '\u00d865 h 30mm',
    id: 10005,
    title: 'Stone',
    url: 'https://www.cuisineshop.fr/moules-silikomart-2/moule-silicone-8-ronds-bombes',
  },
  {
    brand: 'Silikomart',
    cavityCount: 35,
    cavityVolume: 5,
    dimensions: '\u00d826 h 13mm',
    id: 10006,
    title: 'Micro Stone',
    url: 'https://www.cuisineshop.fr/moules-silikomart-2/moule-en-silicone-35-micro-ronds-bombes',
  },
  {
    brand: 'Silikomart',
    cavityCount: 1,
    cavityVolume: 735,
    dimensions: '190mm x 70mm x h 57mm',
    id: 10007,
    title: 'Cake PH20',
    url: 'https://professional.silikomart.com/eng/cake-ph-20',
  },
  {
    brand: "Pastry'evo",
    cavityCount: 1,
    cavityVolume: 537,
    dimensions: '160mm x 67mm x h 55mm',
    id: 10008,
    title: 'Moule Oblong Aurélien Cohen',
    url: 'https://www.pastryevo.fr/produit/moule-silicone-oblong-du-chef-aurelien-cohen/',
  },
  {
    brand: 'Silikomart',
    cavityCount: 6,
    cavityVolume: 65,
    dimensions: '\u00d885/50mm x h18mm | \u00d875/60mm x h8mm',
    id: 10009,
    title: 'Kit The Ring',
    url: 'https://www.silikomart.com/fr/kit-the-ring',
  },
  {
    brand: 'Pavoni',
    cavityCount: 12,
    cavityVolume: 93,
    dimensions: '\u00d866mm x h34mm',
    id: 10010,
    title: 'Planet PX4321',
    url: 'https://pavonitalia.com/professional/en/catalog/product/view/id/3152/s/planet-px4321/',
  },
  {
    brand: 'Pavoni',
    cavityCount: 30,
    cavityVolume: 18,
    dimensions: '\u00d838mm x h20mm',
    id: 10011,
    title: 'Planet PX4323',
    url: 'https://pavonitalia.com/professional/en/catalog/product/view/id/3145/s/planet-px4323/',
  },
];
